module.exports = __webpack_public_path__ + "img/img01.a606ea5b.png";